import {AutoSaveFeedbackStatusEnum} from "@/models/enum/AutoSaveFeedbackStatusEnum";

export class UIStateDto {
    private _isReady: boolean;
    private _isSubmitting: boolean;
    private _isDeleting: boolean;
    private _deletingItems: Set<string> = new Set();
    private _canSubmit: boolean;
    private _autoSaveFeedbackStatus: AutoSaveFeedbackStatusEnum
    private error: string | null;

    constructor() {
        this._isReady = false;
        this._isSubmitting = false;
        this._isDeleting = false;
        this._canSubmit = true;
        this._autoSaveFeedbackStatus = AutoSaveFeedbackStatusEnum.NONE;
        this.error = null;
    }

    public static createWithDefaults(): UIStateDto {
        return new this();
    }

    public isReady(): boolean {
        return this._isReady;
    }

    public isNotReady(): boolean {
        return !this._isReady;
    }

    public getIsReady(): boolean {
        return this._isReady;
    }

    public setReady(): UIStateDto {
        this._isReady = true;

        return this;
    }

    public setNotReady(): UIStateDto {
        this._isReady = false;

        return this;
    }

    public setIsReady(isReady: boolean): UIStateDto {
        this._isReady = isReady;

        return this;
    }

    public isSubmitting(): boolean {
        return this._isSubmitting;
    }

    public setSubmitting(): UIStateDto {
        this._isSubmitting = true;

        return this;
    }

    public setNotSubmitting(): UIStateDto {
        this._isSubmitting = false;

        return this;
    }

    public setIsSubmitting(isSubmitting: boolean): UIStateDto {
        this._isSubmitting = isSubmitting;

        return this;
    }

    public isDeleting(): boolean {
        return this._isDeleting;
    }

    public setDeleting(): UIStateDto {
        this._isDeleting = true;

        return this;
    }

    public setNotDeleting(): UIStateDto {
        this._isDeleting = false;

        return this;
    }

    public setIsDeleting(isDeleting: boolean): UIStateDto {
        this._isDeleting = isDeleting;

        return this;
    }

    public isItemDeleting(itemKey: string): boolean {
        return this._deletingItems.has(itemKey);
    }

    public isAnyItemDeleting(): boolean {
        return this._deletingItems.size > 0;
    }

    public setItemDeleting(itemKey: string): UIStateDto {
        this._deletingItems.add(itemKey);

        return this;
    }

    public removeItemDeleting(itemKey: string): UIStateDto {
        this._deletingItems.delete(itemKey);

        return this;
    }

    public canSubmit(): boolean {
        return this._canSubmit;
    }

    public getCanSubmit(): boolean {
        return this._canSubmit;
    }

    public setCanSubmit(canSubmit: boolean): UIStateDto {
        this._canSubmit = canSubmit;

        return this;
    }

    public getAutoSaveFeedbackStatus(): AutoSaveFeedbackStatusEnum {
        return this._autoSaveFeedbackStatus;
    }

    public setAutoSaveFeedbackStatus(autoSaveFeedbackStatus: AutoSaveFeedbackStatusEnum): UIStateDto {
        this._autoSaveFeedbackStatus = autoSaveFeedbackStatus;

        return this;
    }

    public getError(): string | null {
        return this.error;
    }

    public hasError(): boolean {
        return this.error !== null;
    }

    public setError(error: string | null): UIStateDto {
        this.error = error;

        return this;
    }

    public clearError(): UIStateDto {
        this.error = null;

        return this;
    }
}
